import { useSelector, useDispatch } from 'react-redux';
import { next } from '../../../../fsm/events';
import {
  getGarageImmobilizationName,
  getGarageImmobilizationFullAddress,
  getCarDestinationFullAddress,
  getCarDestinationProviderName,
} from '../../../../selectors/coreApi';
import { VEHICLE_GARAGE_LOCATION_CORRECT } from '../../../../ducks/rentalMission';

export const useConnect = () => {
  const dispatch = useDispatch();
  return {
    currentGarageName: useSelector(getGarageImmobilizationName),
    currentGarageAddress: useSelector(getGarageImmobilizationFullAddress),
    vehicleDestinationName: useSelector(getCarDestinationProviderName),
    vehicleDestinationAddress: useSelector(getCarDestinationFullAddress),
    next: payload => dispatch(next(payload)),
    vehicleGarageLocationCorrect: () => {
      dispatch({ type: VEHICLE_GARAGE_LOCATION_CORRECT });
    },
  };
};
